import { CommonModule } from '@angular/common';
import { Component, effect, inject, OnInit, signal } from '@angular/core';
import { VbLxpMapComponent } from '../../map/map.component';
import { RaceSessionService } from '../../timing-tower/race-session.service';
import { VbLxpPanelComponent } from '../../panel/vb-lxp-panel.component';
import { PanelService } from '../../panel/panel.service';
import { FavoriteDriverService } from '../../shared/favorite-driver.service';

@Component({
	selector: 'vb-lxp-map-page.component',
	imports: [VbLxpMapComponent, CommonModule, VbLxpPanelComponent],
	templateUrl: './vb-lxp-map-page.component.html',
	styleUrl: './vb-lxp-map-page.component.css',
})
export class VbLxpMapPageComponent implements OnInit {
	private readonly raceSessionService = inject(RaceSessionService);
	public readonly panelService = inject(PanelService);
	public readonly favoriteDriverService = inject(FavoriteDriverService);

	selectedDrivers = signal([]);

	readonly drivers = this.raceSessionService.raceTeamsPosition;

	constructor() {
		const driversRef = effect(() => {
			if (this.drivers().length !== 0) {
				this.setFavoriteDrivers();
				driversRef.destroy();
			}
		});
	}

	public ngOnInit(): void {
		this.panelService.registerPanel('map-drivers');
	}

	onDriverClick(driver: any) {
		if (this.selectedDrivers().includes(driver.number)) {
			this.selectedDrivers.update((sd) => sd.filter((d) => d !== driver.number));
		} else {
			this.selectedDrivers.update((sd) => [...sd, driver.number]);
		}
	}

	setFavoriteDrivers() {
		const favoriteDrivers = this.raceSessionService
			.raceTeamsPosition()
			.filter((t) => this.favoriteDriverService.isFavoriteDriver(t));
		this.selectedDrivers.set(favoriteDrivers.map((fd) => fd.number));
	}
}
